<template>
  <div class="lawofflatserve">
    <sub-title text="最新律所服务" />
    <div class="servelist">
      <div class="serveitem" v-for="item in 3" :key="item">
        <div class="time">52分钟</div>
        <div class="jj flex_start">
          <div><img src="../../../assets/base/small_rentou.png" alt="" /></div>
          <div><span>XX律师</span>对<span>分割财产</span>的订单提供 了服务</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.lawofflatserve {
  width: 100%;
  height: 100%;
  padding: 23px 12px 24px;
  .servelist {
      padding-top: 1px;
    .serveitem {
        margin-top: 22px;
      .time {
        font-size: 14px;
        color: #999999;
        line-height: 14px;
        margin-bottom: 10px;
      }
      .jj {
        font-size: 16px;
        color: #999999;
        line-height: 20px;
        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          margin-right: 10px;
        }
        span {
          color: #333333;
        }
      }
    }
  }
}
</style>